import DiseaseEncyclopediaModel from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';
import { Client } from '@/types/app';
import { cn } from '@/utils/style';

interface Props {
  client: Client;
  shouldShowDiseaseImage: boolean;
  shouldShowDepartmentTags: boolean;
  shouldShowSymptomTags: boolean;
  title: string;
  diseaseEncyclopedia?: DiseaseEncyclopediaModel;
  joinedDepartmentTags: string;
  joinedSymptomTags: string;
}

const DiseaseEncyclopediaHeader = (props: Props) => {
  const isMobileEnv = props.client.isMobile;
  return (
    <div
      className={cn(
        'flex pb-[32px]',
        { 'flex-col': isMobileEnv },
        {
          'pt-[28px] pr-[24px]': !isMobileEnv,
        },
        {
          'gap-[32px]': props.shouldShowDiseaseImage,
        }
      )}
    >
      <div className={cn('flex flex-col gap-[4px]', { 'ml-[24px]': !isMobileEnv })}>
        {props.shouldShowDiseaseImage && (
          <img
            src={props.diseaseEncyclopedia?.getTitleImageUrl() ?? ''}
            alt='title-image'
            className={cn('object-cover', {
              'aspect-[160/160] h-auto w-full': isMobileEnv,
              'h-[160px] w-[160px] rounded-[12px]': !isMobileEnv,
            })}
          />
        )}
      </div>
      <div className={cn('flex flex-col justify-center gap-[12px]', { 'mx-[24px]': isMobileEnv })}>
        <h1 className='typography-ui-24b text-gray-900'>{props.title}</h1>
        <div className='flex flex-col gap-[8px]'>
          {props.shouldShowDepartmentTags && (
            <div className='flex items-start gap-[20px]'>
              <span className='typography-ui-15m min-w-[40px] text-gray-400'>진료과</span>
              <div className='flex flex-wrap gap-[6px]'>
                <span className='typography-ui-15r text-gray-900'>{props.joinedDepartmentTags}</span>
              </div>
            </div>
          )}
          {props.shouldShowSymptomTags && (
            <div className='flex items-start gap-[20px]'>
              <span className='typography-ui-15m min-w-[40px] text-gray-400'>증상</span>
              <div className='flex flex-wrap gap-[6px]'>
                <span className='typography-ui-15r text-gray-900'>{props.joinedSymptomTags}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiseaseEncyclopediaHeader;
